const SET_LOCATION = 'novelApp/location/SET_LOCATION'

export default {
  SET_LOCATION
}
